import * as React from "react"
import {useStaticQuery, graphql, Link} from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import {fontFaceMoontime,headStyle,bgStyle,fontWhite} from './mckCares.module.scss'

const McKCares = ()=>{
      const data = useStaticQuery(graphql`
        query {
          contentfulSpecialBlocks(blockTitle: {eq: "McKinley Cares"}) {
            id
            blockTitle
            blockText {
              blockText
            }
            blockImage {
              gatsbyImageData
            }
            blockImageTwo {
              gatsbyImageData
            }
          }
        }
        `
      )

      const image = getImage(data.contentfulSpecialBlocks.blockImage.gatsbyImageData)
      const image2 = getImage(data.contentfulSpecialBlocks.blockImageTwo.gatsbyImageData)
    return(
        <section className={bgStyle}>
            <br />
            <br />
            <div className=" container">
                <div className="columns is-vcentered is-mobile is-multiline">
                    <div className="column is-half-desktop is-full-mobile">
                        <h1 className={fontFaceMoontime+' '+headStyle}>McKinley Cares</h1>
                        <p className={fontWhite}>{data.contentfulSpecialBlocks.blockText.blockText}</p>
                        <br />
                        <p><Link to="/cares/" className="button">Explore McKinley Cares</Link></p>
                    </div>
                    <div className="column">
                        {image && <GatsbyImage image={image} alt="McKinley Cares"  style={{maxHeight:'212px'}}/>}
                    </div>
                    {image2 && <div className="column"><GatsbyImage image={image2} alt="McKinley Cares Again"  style={{maxHeight:'212px'}}/></div>}
                </div>
            </div>
            <br />
            <br />
        </section>
    )
}


export default McKCares
